module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-lightning-rain-62bd6b04.svg";